import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginApi } from "../Services/Login";
import { useUserSuperEmpresa } from "../Context/AuthContext";
import "../Css/Login.css"
import { CircularProgress } from "@mui/material";

/* imagen */
import logo from "../Image/log-blanco.png"
import titulo from "../Image/textoblanco.png"
/* iconos */
import { FaUser } from "react-icons/fa";
import { BiSolidLock } from "react-icons/bi";
import { BiSolidLockOpen } from "react-icons/bi";
import { MdWarning } from "react-icons/md";

export const PagesLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
   const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // 👇 funciones desde el contexto
  const { setAdminUserEmpresaToken, setUserInformationUsuario } = useUserSuperEmpresa();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await LoginApi({ email, password });

      // Guardar token y usuario en el contexto
      setAdminUserEmpresaToken(data.token);
      setUserInformationUsuario(data.user);

      // Redirigir
      navigate("/inicio");
    } catch (err) {
      setError("Usuario o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        
        <div className="login-left">
           <div className="divcolorbasedos"></div> 
  <div className="divcolorbaseuno"></div>
  <div className="divcolorunodos"></div>
  <div className="titulologin">
    <div className="logoicono">
        <img src={logo} alt="clinica activa" />
    </div>
     <div className="titulolog">
        <img src={titulo} alt="clinica activa" />
    </div>
        
     
  </div>
     
        </div>

        <div className="login-right">
        <div className="login-box">
  <h1 className="login-title">Bienvenido al Sistema Contable</h1>
  <h2 className="login-subtitle">Alemana Activa</h2>
  <p className="login-text">Por favor, inicia sesión para continuar</p>
</div>
        
    <form onSubmit={handleSubmit} className="login-form">
      {/* Campo Usuario */}
      <div className="input-group">
        <FaUser className="input-icon" />
        <input
          type="email"
          placeholder="Usuario"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      {/* Campo Contraseña */}
      <div className="input-group">
        {showPassword ? (
          <BiSolidLockOpen
            className="input-icon-right"
            onClick={() => setShowPassword(false)}
          />
        ) : (
          <BiSolidLock
            className="input-icon-right"
            onClick={() => setShowPassword(true)}
          />
        )}
        <input
          type={showPassword ? "text" : "password"}
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

          {/* Mensaje de error */}
            {error && (
              <div className="error-message">
                <MdWarning className="error-icon" />
                <span>{error}</span>
              </div>
            )}

      <button type="submit" className="login-btn">
          {loading ? <CircularProgress size={24} color="inherit" /> : "Iniciar Sesión"}
      </button>
    </form>

      

       
        </div>
      </div>
    </div>
  );
};
